<div
  data-cy="Calendar:Event"
  class="event-container px-8 rounded cursor-pointer text-base-white relative flex flex-col items-start leading-[normal]"
  [class.py-8]="!shrink"
  [class.justify-center]="!displaySecondLine"
  [style.height.px]="height"
  [style.fontSize]="effectiveFontSize"
  [style]="calendarEventLayout.event.styles"
  [blazeTooltip]="calendarEventLayout.event.title"
  matTooltipPosition="above"
  (click)="onEventClick()"
>
  <div
    class="w-full text-left"
    [class.line-clamp-1]="titleLines === 1"
    [class.line-clamp-2]="titleLines === 2"
    data-cy="Calendar:Event:Title"
  >
    {{ calendarEventLayout.event.title }}
  </div>
  @if (displaySecondLine) {
    <div
      class="overflow-hidden whitespace-nowrap overflow-ellipsis w-full text-left shrink-0"
      data-cy="Calendar:Event:Time"
    >
      {{ time }}
    </div>
  }
</div>
<ng-content />
